class Archive{
    constructor() {
        this.archive = document.querySelector('.product-archive');
        this.sorting = this.archive ? this.archive.querySelector('.woocommerce-sorting') : false;
        if(this.sorting) this.sortSelect(this.sorting);
    }
    sortSelect(el){
        el.addEventListener('change', e => {
            let url = new URL(el.dataset.url),
                select = e.target.value;
            if(select) url.searchParams.append('filtr', select);
            location.assign(url.href);
        });
    }
    
}

export default  Archive;